<h2 mat-dialog-title>Join Society</h2>
<div mat-dialog-content>
  <form [formGroup]="joinSocietyForm" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
    <div class="row gx-4 my-2">

      <!-- Society -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Society</mat-label>
       <input type="text" matInput [matAutocomplete]="autoSociety" formControlName="account_id" placeholder="Search society"
        />
        <mat-autocomplete #autoSociety="matAutocomplete" [displayWith]="displaySociety">
          <mat-option *ngFor="let soc of filteredSocieties | async" [value]="soc">
            {{ soc.account_name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="joinSocietyForm.get('account_id')?.hasError('required')">Society is required</mat-error>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
      </mat-form-field>

      <!-- Block -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Block</mat-label>
        <input type="text" matInput [matAutocomplete]="autoBlock" formControlName="block_id" placeholder="Search block" />
        <mat-autocomplete #autoBlock="matAutocomplete" [displayWith]="displayBlock">
          <mat-option *ngFor="let blk of filteredBlocks | async" [value]="blk">{{ blk.name }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="joinSocietyForm.get('block_id')?.hasError('required')">Block is required</mat-error>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
      </mat-form-field>

      <!-- Floor -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Floor</mat-label>
        <input type="text" matInput [matAutocomplete]="autoFloor" formControlName="floor_id" placeholder="Search floor" />
        <mat-autocomplete #autoFloor="matAutocomplete" [displayWith]="displayFloor">
          <mat-option *ngFor="let flr of filteredFloors | async" [value]="flr">{{ flr.name }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="joinSocietyForm.get('floor_id')?.hasError('required')">Floor is required</mat-error>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
      </mat-form-field>

      <!-- Floor Unit -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Floor Unit</mat-label>
        <input type="text" matInput [matAutocomplete]="autoUnit" formControlName="floor_unit" placeholder="Search unit" />
        <mat-autocomplete #autoUnit="matAutocomplete" [displayWith]="displayUnit">
          <mat-option *ngFor="let unt of filteredUnits | async" [value]="unt">{{ unt.name }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="joinSocietyForm.get('floor_unit')?.hasError('required')">Floor unit is required</mat-error>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
      </mat-form-field>

      <!-- Upload Attachment -->
      <div class="col-md-6 mb-2">
        <label class="my-1">Upload Attachment</label>
        <div class="file-info mb-1 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="width: 100%;">
            <button type="button" mat-button color="primary" class="upload-button btn btn-sm">
              <input type="file" formControlName="documents" class="file-input"
                     (change)="onFileSelected($event)" style="display: none;" #fileInput />
              <span (click)="fileInput.click()">Choose file</span>
            </button>
          </div>
        </div>

        <!-- Image Preview -->
        <div class="d-flex align-items-center" *ngIf="attachmentPreview">
          <img [src]="attachmentPreview" alt="Uploaded Image" width="100" height="100"
               style="object-fit: cover; margin-right: 10px;">
          <button type="button" mat-icon-button color="warn" (click)="deleteFile()">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

    </div>

    <!-- Actions -->
    <div mat-dialog-actions align="end" class="mt-3">
      <button mat-button type="button" (click)="closeDialog()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="joinSocietyForm.invalid || loading">Join Society</button>
    </div>
  </form>
</div>
